import EventEmitter = require("eventemitter3");

export default class EventDispatcher extends EventEmitter {
    public logEventsEnabled: boolean = false;
    public instanceId: string = "EventDispatcher";

    public dispatch(event: string, data?: any): void {
        this.emit(event, data);
    }

    public emit(event: string | symbol, data?: any): boolean {
        if (this.logEventsEnabled) {
            this.logEvent(event, data);
        }

        return super.emit(event, data);
    }

    protected logEvent(event: string | symbol, data?: any): void {
        console.groupCollapsed(`${this.instanceId}: ${event.toString()}`);
        console.log(data ? data : "-=NO_DATA=-");
        console.trace();
        console.groupEnd();
    }
}